












import { Component, Prop, Vue } from 'vue-property-decorator';
import { getYear, getMonth } from 'date-fns';
import { Warning, Info } from '@/pages/profile/components';

@Component({
  components: {
    Info,
    Warning,
  },
})
export default class ListBlock extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<any>;

  @Prop({ type: Number, default: 1 })
  readonly month!: number;

  @Prop({ type: Number, default: 2020 })
  readonly year!: number;

  get filteredData() {
    const { items, month, year } = this;
    return items.filter(
      ({ date }) =>
        !date.length || (getYear(date) === year && getMonth(date) === month - 1)
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/list/ListBlock.vue